<template>
  <form novalidate>
    <h4 class="h4 text--bold text--uppercase">Sobre el ataque que se está atendiendo</h4>

    <form-group :error="errors.has('fecha-ataque')">
      <datetime
        :disabled="!editando"
        v-model="form.fechaAtaque"
        v-validate="'required'"
        :use12-hour="true"
        input-class="form__input"
        name="fecha-ataque"
        value-zone="local"
        type="date"/>
      <label class="form__label form__label--required">20. ¿En qué fecha se dio el ataque?</label>
    </form-group>

    <form-group :error="errors.has('momento-ataque') && submitted">
      <label class="form__label form__label--required">
        21. Momento del ataque
      </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.momentoAtaque"
        id="deDiamomentoAtaque"
        name="momento-ataque"
        v-validate="'required'"
        value="De día">
        <label class="form__label" for="deDiamomentoAtaque">De día</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.momentoAtaque"
        id="deNochemomentoAtaque"
        name="momento-ataque"
        v-validate="'required'"
        value="De noche">
        <label class="form__label" for="deNochemomentoAtaque">
          De noche
        </label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.momentoAtaque"
        id="nsnrmomentoAtaque"
        name="momento-ataque"
        v-validate="'required'"
        value="NS/NR">
        <label class="form__label" for="nsnrmomentoAtaque">
          NS/NR
        </label>
      </div>
    </form-group>

    <form-group :error="errors.has('tipo-ave') && submitted">
      <label class="form__label form__label--required">
        22. Tipo de ave atacada
      </label>
      <div class="checkbox checkbox--azul">
        <input v-validate="'required'"
        :disabled="!editando" type="checkbox" id="galloGallinatiposAvesAtacadas" name="tipo-ave"
        v-model="form.tiposAvesAtacadas" value="Gallo/Gallina">
        <label class="form__label" for="galloGallinatiposAvesAtacadas">Gallo/Gallina</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input v-validate="'required'"
        :disabled="!editando" type="checkbox" id="pollotiposAvesAtacadas" name="tipo-ave"
        v-model="form.tiposAvesAtacadas" value="Pollo">
        <label class="form__label" for="pollotiposAvesAtacadas">Pollo</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input v-validate="'required'"
        :disabled="!editando" type="checkbox" id="patotiposAvesAtacadas" name="tipo-ave"
        v-model="form.tiposAvesAtacadas" value="Pato">
        <label class="form__label" for="patotiposAvesAtacadas">
          Pato
        </label>
      </div>
      <div class="checkbox checkbox--azul">
        <input v-validate="'required'"
        :disabled="!editando" type="checkbox" id="gansotiposAvesAtacadas"
        v-model="form.tiposAvesAtacadas" value="Ganso">
        <label class="form__label" for="gansotiposAvesAtacadas">Ganso</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input v-validate="'required'"
        :disabled="!editando" type="checkbox" id="pavorealtiposAvesAtacadas"
        v-model="form.tiposAvesAtacadas" value="Pavo real">
        <label class="form__label" for="pavorealtiposAvesAtacadas">Pavo real</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input v-validate="'required'"
        :disabled="!editando" type="checkbox" id="chompipetiposAvesAtacadas"
        v-model="form.tiposAvesAtacadas" value="Chompipe">
        <label class="form__label" for="chompipetiposAvesAtacadas">Chompipe</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input v-validate="'required'"
        :disabled="!editando" type="checkbox" id="otrotiposAvesAtacadas"
        v-model="form.tiposAvesAtacadas" value="Otra">
        <label class="form__label" for="otrotiposAvesAtacadas">
          Otro / Comentarios adicionales
        </label>
      </div>
      <div class="identado">
        <form-group :error="errors.has('otra-ave-atacada') && submitted"
        v-if="form.tiposAvesAtacadas.includes('Otra')">
          <input
          data-vv-validate-on="blur"
          :disabled="!editando"
          type="text"
          class="form__input"
          v-model="form.otraAveAtacada"
          name="otra-ave-atacada"
          required
          v-validate="'required'">
          <label class="form__label">
            Especifique cual otra:
          </label>
        </form-group>
      </div>
    </form-group>

    <form-group :error="errors.has('cantidad-aves-atacadas') && submitted">
      <input
      data-vv-validate-on="blur"
      :disabled="!editando"
      type="number"
      class="form__input"
      v-model.number="form.cantAvesAtacadas"
      required
      name="cantidad-aves-atacadas"
      v-validate="'required'">
      <label class="form__label">23. Cantidad de aves atacadas</label>
    </form-group>

    <form-group :error="errors.has('sexo-animal-atacado') && submitted">
      <label class="form__label form__label--required">
        24. Sexo del animal atacado
      </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.sexoAnimalAtacado"
        id="machosexoAnimalAtacado"
        name="sexo-animal-atacado"
        v-validate="'required'"
        value="Macho">
        <label class="form__label" for="machosexoAnimalAtacado">Macho</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.sexoAnimalAtacado"
        id="hembrasexoAnimalAtacado"
        name="sexo-animal-atacado"
        v-validate="'required'"
        value="Hembra">
        <label class="form__label" for="hembrasexoAnimalAtacado">Hembra</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.sexoAnimalAtacado"
        id="ambosSexosAnimalAtacado"
        name="sexo-animal-atacado"
        v-validate="'required'"
        value="Ambos sexos">
        <label class="form__label" for="ambosSexosAnimalAtacado">Ambos sexos</label>
      </div>
    </form-group>

    <form-group :error="errors.has('peso-animal-atacado') && submitted">
      <label class="form__label form__label--required">
        25. Peso en kilogramos del animal atacado
      </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.pesoAnimalAtacado"
        id="menos2kgpesoAnimalAtacado"
        name="peso-animal-atacado"
        v-validate="'required'"
        value="Menos de 2kg">
        <label class="form__label" for="menos2kgpesoAnimalAtacado">Menos de 2kg</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.pesoAnimalAtacado"
        id="2kgpesoAnimalAtacado"
        name="peso-animal-atacado"
        v-validate="'required'"
        value="2kg">
        <label class="form__label" for="2kgpesoAnimalAtacado">2kg</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.pesoAnimalAtacado"
        id="4kgpesoAnimalAtacado"
        name="peso-animal-atacado"
        v-validate="'required'"
        value="4kg">
        <label class="form__label" for="4kgpesoAnimalAtacado">4kg</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.pesoAnimalAtacado"
        id="6kgpesoAnimalAtacado"
        name="peso-animal-atacado"
        v-validate="'required'"
        value="6kg">
        <label class="form__label" for="6kgpesoAnimalAtacado">6kg</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.pesoAnimalAtacado"
        id="8kgpesoAnimalAtacado"
        name="peso-animal-atacado"
        v-validate="'required'"
        value="8kg">
        <label class="form__label" for="8kgpesoAnimalAtacado">8kg</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.pesoAnimalAtacado"
        id="10kgpesoAnimalAtacado"
        name="peso-animal-atacado"
        v-validate="'required'"
        value="10kg">
        <label class="form__label" for="10kgpesoAnimalAtacado">10kg</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.pesoAnimalAtacado"
        id="12kgpesoAnimalAtacado"
        name="peso-animal-atacado"
        v-validate="'required'"
        value="12kg">
        <label class="form__label" for="12kgpesoAnimalAtacado">12kg</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.pesoAnimalAtacado"
        id="14kgpesoAnimalAtacado"
        name="peso-animal-atacado"
        v-validate="'required'"
        value="14kg">
        <label class="form__label" for="14kgpesoAnimalAtacado">14kg</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.pesoAnimalAtacado"
        id="16kgpesoAnimalAtacado"
        name="peso-animal-atacado"
        v-validate="'required'"
        value="16kg">
        <label class="form__label" for="16kgpesoAnimalAtacado">16kg</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.pesoAnimalAtacado"
        id="18kgpesoAnimalAtacado"
        name="peso-animal-atacado"
        v-validate="'required'"
        value="18kg">
        <label class="form__label" for="18kgpesoAnimalAtacado">18kg</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.pesoAnimalAtacado"
        id="20kgpesoAnimalAtacado"
        name="peso-animal-atacado"
        v-validate="'required'"
        value="20kg">
        <label class="form__label" for="20kgpesoAnimalAtacado">20kg</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.pesoAnimalAtacado"
        id="mayor20kgpesoAnimalAtacado"
        name="peso-animal-atacado"
        v-validate="'required'"
        value="Más de 20kg">
        <label class="form__label" for="mayor20kgpesoAnimalAtacado">Más de 20kg</label>
      </div>
      <div class="identado">
        <form-group :error="errors.has('otro-peso-animal-atacado') && submitted"
        v-if="form.pesoAnimalAtacado === 'Más de 20kg'">
          <input
          data-vv-validate-on="blur"
          :disabled="!editando"
          type="number"
          class="form__input"
          v-model.number="form.otroPesoAnimalAtacado"
          name="otro-peso-animal-atacado"
          required
          v-validate="'required'">
          <label class="form__label">
            ¿Aproximadamente cuántos kg?
          </label>
        </form-group>
      </div>
    </form-group>

    <form-group :error="errors.has('salud-atacado') && submitted">
      <label class="form__label form__label--required">
        26. Estado de salud/condición del animal atacado
      </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.saludAnimalAtacado"
        id="sanokgsaludAnimalAtacado"
        name="salud-atacado"
        v-validate="'required'"
        value="Sano">
        <label class="form__label" for="sanokgsaludAnimalAtacado">Sano</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.saludAnimalAtacado"
        id="enfermosaludAnimalAtacado"
        name="salud-atacado"
        v-validate="'required'"
        value="Enfermo">
        <label class="form__label" for="enfermosaludAnimalAtacado">Enfermo</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.saludAnimalAtacado"
        id="lesionadosaludAnimalAtacado"
        name="salud-atacado"
        v-validate="'required'"
        value="Lesionado">
        <label class="form__label" for="lesionadosaludAnimalAtacado">Lesionado</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.saludAnimalAtacado"
        id="preñadasaludAnimalAtacado"
        name="salud-atacado"
        v-validate="'required'"
        value="Preñada">
        <label class="form__label" for="preñadasaludAnimalAtacado">Preñada</label>
      </div>
    </form-group>

    <form-group :error="errors.has('resultado-ataque') && submitted">
      <label class="form__label form__label--required">
        27. Resultado del ataque
      </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.resultadoAnimalAtacado"
        id="1resultadoAnimalAtacado"
        name="resultado-ataque"
        v-validate="{ required: !form.resultadoAnimalAtacadoCheckOtro }"
        value="Herido y luego murió">
        <label class="form__label" for="1resultadoAnimalAtacado">Herido y luego murió</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.resultadoAnimalAtacado"
        id="2resultadoAnimalAtacado"
        name="resultado-ataque"
        v-validate="{ required: !form.resultadoAnimalAtacadoCheckOtro }"
        value="Herido pero sigue vivo">
        <label class="form__label" for="2resultadoAnimalAtacado">Herido pero sigue vivo</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.resultadoAnimalAtacado"
        id="3resultadoAnimalAtacado"
        name="resultado-ataque"
        v-validate="{ required: !form.resultadoAnimalAtacadoCheckOtro }"
        value="Muerto pero no comió">
        <label class="form__label" for="3resultadoAnimalAtacado">Muerto pero no comió</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.resultadoAnimalAtacado"
        id="4resultadoAnimalAtacado"
        name="resultado-ataque"
        v-validate="{ required: !form.resultadoAnimalAtacadoCheckOtro }"
        value="Muerto y comido">
        <label class="form__label" for="4resultadoAnimalAtacado">Muerto y comido</label>
      </div>
      <div class="checkbox checkbox--azul">
        <input
        :disabled="!editando"
        type="checkbox"
        v-model="form.resultadoAnimalAtacadoCheckOtro"
        id="5resultadoAnimalAtacado"
        name="resultado-ataque">
        <label class="form__label" for="5resultadoAnimalAtacado">
          Otro / Comentarios adicionales
        </label>
      </div>
      <div class="identado">
        <form-group :error="errors.has('otra-resultado-ataque') && submitted"
        v-if="form.resultadoAnimalAtacadoCheckOtro">
          <input
          data-vv-validate-on="blur"
          :disabled="!editando"
          type="text"
          class="form__input"
          v-model="form.otroResultadoAnimalAtacado"
          name="otra-resultado-ataque"
          required
          v-validate="'required'">
          <label class="form__label">
            Especifique:
          </label>
        </form-group>
      </div>
    </form-group>

    <form-group :error="errors.has('valor-animal-atacado') && submitted">
      <input
      data-vv-validate-on="blur"
      :disabled="!editando"
      type="number"
      class="form__input"
      v-model.number="form.valorAnimalAtacado"
      required
      name="valor-animal-atacado"
      v-validate="'required'">
      <label class="form__label">28. Valor aproximado en colones del animal atacado</label>
    </form-group>

    <form-group :error="errors.has('ver-huellas-depredador') && submitted">
      <label class="form__label form__label--required">
        29. ¿Logró ver las huellas del posible depredador?
      </label>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.verHuellasDepredador"
        id="siverHuellasDepredador"
        name="ver-huellas-depredador"
        v-validate="'required'"
        :value="true">
        <label class="form__label" for="siverHuellasDepredador">Si</label>
      </div>
      <div class="radio radio--azul">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.verHuellasDepredador"
        id="noverHuellasDepredador"
        name="ver-huellas-depredador"
        v-validate="'required'"
        :value="false">
        <label class="form__label" for="noverHuellasDepredador">No</label>
      </div>
    </form-group>

    <form-group :error="errors.has('imagen-huellas') && submitted"
    v-if="form.verHuellasDepredador">
      <div class="identado" v-if="form.verHuellasDepredador">
        <label class="form__label form__label--required">
          ¿A cual de estas se parece?
        </label>
        <p class="text">
          OPCIONAL: Si el ganadero tiene registro fotográfico, pedírsela y adjuntarla en el bloque
          &quot;Adjuntos&quot;
        </p>
      </div>
      <div class="flex--container">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.huellasDepredador"
        id="1huellasDepredador"
        name="imagen-huellas"
        v-validate="'required'"
        value="1">
        <label class="form__label" for="1huellasDepredador">
          <img src="/huella-coyote.jpg" width="100%">
        </label>
      </div>
      <div class="flex--container">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.huellasDepredador"
        id="2huellasDepredador"
        name="imagen-huellas"
        v-validate="'required'"
        value="2">
        <label class="form__label" for="2huellasDepredador">
          <img src="/huella-jaguar.jpg" width="100%">
        </label>
      </div>
      <div class="flex--container">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.huellasDepredador"
        id="3huellasDepredador"
        name="imagen-huellas"
        v-validate="'required'"
        value="3">
        <label class="form__label" for="3huellasDepredador">
          <img src="/huella-puma.jpg" width="100%">
        </label>
      </div>
      <div class="flex--container">
        <input
        :disabled="!editando"
        type="radio"
        v-model="form.huellasDepredador"
        id="4huellasDepredador"
        name="imagen-huellas"
        v-validate="'required'"
        value="4">
        <label class="form__label" for="4huellasDepredador">
          <img src="/huella-ocelote.jpg" width="100%">
        </label>
      </div>
    </form-group>
  </form>
</template>

<script>
export default {
  name: "FormAvesBloque4",
  props: {
    editando: Boolean,
    submitted: Boolean,
    form: Object,
  },
  methods: {
    validar,
  },
};

function validar() {
  return this.$validator.validate();
}
</script>
<style>
.flex--container {
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: center;
}
</style>
